export class MockPeoplesService {
  getPeople = jasmine.createSpy('getPeople');
}
